module.exports = __webpack_public_path__ + "static/media/v6.668de940.mp4";